import React, { useState, useEffect } from 'react';
import {
  Input,
  Label,
  Button,
} from "reactstrap";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker  } from "@mui/x-date-pickers";
import Typography from "@mui/material/Typography";
import Countdown from "./countdown";
import Progress from "./progress";

import widgetEventCountdown from "../../../assets/images/icons-component/countdown.png";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, scale, onUpdate, actionEnd, open, setIsOpen } = props;
  const [eventType, setEventType] = useState(config.data?.eventType? config.data?.eventType : "countdown");
  const [eventName, setEventName] = useState(config.data?.eventName? config.data?.eventName : "");
  const [eventNameFontSize, setEventNameFontSize] = useState<number>(config.data?.eventNameFontSize? config.data?.eventNameFontSize : 30);
  const [startDate, setStartDate] = useState(config.data?.startDate? config.data?.startDate : dayjs());
  const [endDate, setEndDate] = useState(config.data?.endDate? config.data?.endDate : dayjs().add(1, 'month'));
  const [isSaved, setIsSaved] = useState(false);
  const [settingEnd, setSettingEnd] = useState(false);
  // 
  const [isIPad, setIsIPad] = useState<boolean>( /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document));

  useEffect(() => {
    if ((config.data && config.data?.eventName) || (config.data && config.data?.startDate) || (config.data && config.data?.endDate) || (config.data && config.data?.eventType)) {
      if (config.data?.eventName) {
        setEventName(config.data?.eventName);
        setEventNameFontSize(config.data?.eventNameFontSize);
      }
      if (config.data?.startDate) {
        setStartDate(dayjs(config.data?.startDate));
      }
      if (config.data?.endDate) {
        setEndDate(dayjs(config.data?.endDate));
      }
      if (config.data?.eventType) {
        setEventType(config.data?.eventType);
      }
      setIsSaved(true);
      if (config.data?.triggered) {
        setSettingEnd(true);
        delete config.data.triggered;
      }
    }
  }, [config.data?.eventName, config.data?.eventNameFontSize, config.data?.startDate, config.data?.endDate, config.data?.eventType]);

  const saveEvent = () => {
    const data = config.data;
    data.eventName = eventName;
    data.startDate = startDate;
    data.endDate = endDate;
    data.eventType = eventType;
    onUpdate({ id: config.id, data: { ...data } });
    actionEnd(true);
    setSettingEnd(true);
  };

  useEffect(() => {
    console.log('isSaved', isSaved);
    
    if (isSaved) {
      saveEvent();
    }
  }, [isSaved]);

  useEffect(() => {
    
  }, [open]);

  return (
    <React.Fragment>
      <div style={{ height: '100%', width: '100%', position: 'absolute' }}>
        <Box className="h-100">
          {!isSaved? (
            <div className="relative flex h-full flex-col items-center justify-center p-6 bg-screen  overflow-hidden" style={{ cursor: 'auto' }}>
              <div className="widget-head">
                <img className="widget-img-icon" src={widgetEventCountdown} alt="" />
              </div>
              <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">活動</p>
              <Button
                color="light"
                className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
                onClick={() => setIsOpen(true)}
                data-interaction-target-type="false"
              >
                <div className="relative justify-center h-100 w-100">
                  <span className="flex items-center justify-center w-100">
                    設定
                  </span>
                </div>
              </Button>
            </div>
          ) : (
            <React.Fragment>
              {eventType === 'countdown'? (
                <Countdown
                  eventName={eventName}
                  eventNameFontSize={eventNameFontSize}
                  endDate={endDate}
                  settingEnd={settingEnd}
                  setSettingEnd={setSettingEnd}
                  scale={scale}
                  isIPad={isIPad}
                />
              ) : (
                <Progress
                  eventName={eventName}
                  eventNameFontSize={eventNameFontSize}
                  startDate={startDate}
                  endDate={endDate}
                  settingEnd={settingEnd}
                  setSettingEnd={setSettingEnd}
                  scale={scale}
                  isIPad={isIPad}
                />
              )}
            </React.Fragment>
          )}
          <Box>
            <Modal
              open={open}
              onClose={() => setIsOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="countdown-modal">
                <Box>
                  <p className="mb-2 mt-4">
                    <span className="crs-title">建立活動</span>
                  </p>
                  <Box>
                    <div className="mt-8 mb-2">
                      <span className="crs-subtitle d-block mt-5 mb-3">
                        活動類型
                        <span className="crs-caption"></span>
                      </span>
                    </div>
                    <Box className="m-0">
                      <FormControl className="m-0">
                        <div className="form-check" onPointerDown={() => setEventType("countdown")}>
                          <Input type="radio" className="form-check-input" id="countdown" name="eventtype" checked={eventType === "countdown"} />
                          <Label className="form-check-label fs-16" htmlFor="countdown">
                            倒數計時
                          </Label>
                        </div>
                        <div className="form-check mt-2" onPointerDown={() => setEventType("progress")}>
                          <Input type="radio" className="form-check-input" id="progress" name="eventtype" checked={eventType === "progress"} />
                          <Label className="form-check-label fs-16" htmlFor="progress">
                            進度
                          </Label>
                        </div>
                      </FormControl>
                    </Box>
                  </Box>
                  <div className="crs-subtitle mt-4">活動名稱</div>
                  <Input
                    autoComplete="one-time-code"
                    className="form-control mt-3"
                    id="event-name"
                    name="event-name"
                    onChange={(event) => setEventName(event.target.value)}
                    type="text"
                    placeholder="輸入活動名稱"
                    value={eventName}
                  />
                  {eventType === "progress"? (
                    <React.Fragment>
                      <div className="crs-subtitle mt-4">開始日期</div>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'zh-tw'}>
                          <DatePicker
                            className="form-control countdown-picker mt-3"
                            value={startDate}
                            onChange={(date: any) => setStartDate(date)}
                          />
                          </LocalizationProvider>
                        </Box>
                    </React.Fragment>
                  ) : null }
                  <div className="crs-subtitle mt-4">結束日期</div>
                  <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'zh-tw'}>
                      <DatePicker
                        className="form-control countdown-picker mt-3"
                        value={endDate}
                        minDate={startDate}
                        onChange={(date) => setEndDate(dayjs(date))}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
                <Box
                  right={0}
                  bottom={0}
                  position='absolute' 
                >
                  <Button 
                    className="rounded-pill"
                    color="error"
                    onClick={() => setIsOpen(false)}
                  >
                    取消
                  </Button>
                  <Button 
                    className="rounded-pill"
                    variant="contained"
                    disabled={eventName.length === 0}
                    onClick={() => {saveEvent(); setIsOpen(false);}}
                  >
                    儲存
                  </Button>
                </Box>
              </Box>
            </Modal>
          </Box>
        </Box>
      </div>
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default Index;